// env-bootstrap.ts

export const configBootstrap = {
  appEnv: process.env.NEXT_PUBLIC_APP_ENV || "development",
  raldEmail: process.env.NEXT_PUBLIC_RALD_EMAIL || "development",
  apiBaseUrl:
    process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:4000/api/v1",

  // Auth Providers
  googleOAuthClientId: process.env.NEXT_PUBLIC_OAUTH_CLIENT_ID || "",
  appleClientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID || "",
  appleRedirectUri:
    process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI ||
    "http://localhost:3000/auth/sign-in",

  // Third-Party Services
  googlePlacesApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY || "",
  recaptchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "",
  whatsappCommunityLink: process.env.NEXT_PUBLIC_WHATSAPP_COMMUNITY_LINK || "",
} as const;

export type ConfigBootstrap = typeof configBootstrap;
